import React from 'react';
import { ReactComponent as ModalIcon } from '../../images/Icons/five_medals.svg';

export default function ModalsHeaderFiveMedals() {

  return (
    <div>
      <div className="ModalsHeader">
        <div>
          <ModalIcon/>
        </div>
      </div>
      <div className="ModalsHeaderShadow"></div>
    </div>
  );
}
